"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("core/constants");
const React = __importStar(require("react"));
const react_router_1 = require("react-router");
const react_router_dom_1 = require("react-router-dom");
const nav_item_1 = __importDefault(require("./nav-item"));
const tab_content_1 = __importDefault(require("./tab-content"));
const container_1 = __importDefault(require("../settings/household-member/container"));
const container_2 = __importDefault(require("../settings/household/container"));
const container_3 = __importDefault(require("../settings/login/container"));
const container_4 = __importDefault(require("../settings/preferences/container"));
const container_5 = __importDefault(require("../settings/profile/container"));
class SubNav extends React.Component {
    render() {
        const { path } = this.props;
        return (React.createElement(tab_content_1.default, { name: "settings" },
            React.createElement("div", { className: "sub-nav" },
                React.createElement("div", { className: "options u-block u-xs-flex" },
                    React.createElement(nav_item_1.default, { id: "profile-tab-button", value: path + '/profile', text: "Profile" }),
                    constants_1.SHOW_FAMILY_MANAGEMENT && (React.createElement(nav_item_1.default, { id: "household-tab-button", value: path + '/household', text: "Household" })),
                    React.createElement(nav_item_1.default, { id: "preferences-tab-button", value: path + '/preferences', text: "Preferences" }),
                    React.createElement(nav_item_1.default, { id: "login-tab-button", value: path + '/login', text: "Log In" })),
                React.createElement("div", { className: "nav-end" })),
            React.createElement("br", null),
            React.createElement("div", { className: "sub-nav-content" },
                React.createElement(react_router_dom_1.Switch, null,
                    React.createElement(react_router_dom_1.Route, { exact: true, path: path, render: () => React.createElement(react_router_1.Redirect, { to: path + '/profile' }) }),
                    React.createElement(react_router_dom_1.Route, { exact: true, path: path + '/profile', component: container_5.default }),
                    React.createElement(react_router_dom_1.Route, { exact: true, path: path + '/household', component: container_2.default }),
                    React.createElement(react_router_dom_1.Route, { exact: true, path: path + '/household/member', component: container_1.default }),
                    React.createElement(react_router_dom_1.Route, { exact: true, path: path + '/preferences', component: container_4.default }),
                    React.createElement(react_router_dom_1.Route, { exact: true, path: path + '/login', component: container_3.default })))));
    }
}
exports.default = SubNav;
